import React from "react";
import { NavLink, Outlet, Link } from "react-router-dom";
import image00 from "../images/G2RadioNetworkLogo.webp";
import image01 from "../images/SewingMachineMiracles.webp";
import partner00 from "../partners/20TheCountdownMagazine.webp";
import partner01 from "../partners/2ndStreetDreams.webp";
import partner02 from "../partners/AirForceRadioNews.webp";
import partner03 from "../partners/AirPlay40.webp";
import partner04 from "../partners/Amazing80s.webp";
import partner05 from "../partners/AmericanRadioJournal.webp";
import partner06 from "../partners/TheArtistInterview.webp";
import partner07 from "../partners/HomecomingRadio.webp";
import partner08 from "../partners/BirdNote.webp";
import partner09 from "../partners/ConsumerAffairs.webp";
import partner10 from "../partners/Dailycast.webp";
import partner11 from "../partners/FaithAndFinance.webp";
import partner12 from "../partners/FeatureStoryNews.webp";
import partner13 from "../partners/HumansInPublicHealth.webp";
import partner14 from "../partners/IntegrityMoments.webp";
import partner15 from "../partners/JazzTrax.webp";
import partner17 from "../partners/MilitaryOneSource.webp";
import partner19 from "../partners/TryItOn.webp";
import partner20 from "../partners/PamSmith.webp";
import partner21 from "../partners/Possibly.webp";
import partner22 from "../partners/PresidentialPrayerTeam.webp";
import partner23 from "../partners/SamaritanHealthMinistries.webp";
import partner24 from "../partners/Outreach.webp";
import partner25 from "../partners/VinylImpressions.webp";
import cyber from "../partners/CyberForensics.webp";
import drive from "../partners/DriveJams.webp";
import monthly from "../partners/MonthlyHousekeeping.webp";
import motive from "../partners/MotivationalMoment.webp";
import weather from "../partners/Weather.webp";

function Home() {
  return (
    <div class="container">
      <div class="row row-cols-1 row-cols-md-3 g-4">
        <div class="col">
          <div class="card h-95">
            <img
              src={image00}
              class="card-img-top"
              alt="G2 Radio Network Logo."
            />
            <div class="card-body">
              <h5 class="card-title">La Mesa Station</h5>
              <p class="station-card-text">
                The G2 Radio Network is an empowering network of radio stations
                that plays a mix of music and programming for all audiences 24
                hours a day. It is our desire that the music we play, and the
                discussions we have are useful, applicable and empowering to
                your daily living. Thank you so much for tuning in today. We
                look forward to playing the music and programming that you want
                to hear.
              </p>
              <div class="d-grid">
                <Link
                  to="/LaMesa"
                  class="btn btn-primary la mesa"
                  role="button"
                >
                  Listen
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="card h-95">
            <img
              src={image00}
              class="card-img-top"
              alt="G2 Radio Network Logo."
            ></img>
            <div class="card-body">
              <h5 class="card-title">YouTube Station</h5>
              <p>New artists featured on our YouTube Channel.</p>
              <div class="d-grid">
                <a
                  class="btn btn-primary lake murray"
                  href="https://www.youtube.com/@g2radionetwork400/featured"
                  role="button"
                  target="_blank"
                  rel="noreferrer"
                >
                  Listen
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card h-95">
            <img
              src={image01}
              class="card-img-top"
              alt="Sewing Machine Miracles Logo."
            ></img>
            <div class="card-body">
              <h5 class="card-title">Sewing Machine Miracles</h5>
              <p>
                Sewing Machine Miracles is a podcast created by Dr. Jason Gordon
                that explores the profound impact of sewing machines both past
                and present, while drawing parallels to the miracles of human
                resilience, creativity and community.
              </p>{" "}
              <p>
                Hear Sewing Machine Miracles daily on the G2 Radio Network La
                Mesa station at the following times: 05:30 AM, 1:30 PM, and 9:30
                PM PST.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="news">
        <iframe
          src="https://dailycast.news/"
          width="100%"
          height="500px"
          frameborder="no"
          title="News"
        ></iframe>
      </div>

      <div class="divider">Our Partners</div>

      <div class="partner-row" id="00">
        <div class="column-polaroid">
          <a
            href="https://www.20thecountdown.com/"
            target="_blank"
            rel="noreferrer"
          >
            <div class="polaroid">
              <img
                loading="lazy"
                src={partner00}
                alt="20 The Countdown Magazine Image."
                style={{ width: "100%" }}
              />
              <div class="polaroid-container">
                <p>20 The Countdown Magazine</p>
              </div>
            </div>
          </a>
        </div>

        <div class="column-polaroid">
          <a
            href="https://secondstreetdreams.com"
            target="_blank"
            rel="noreferrer"
          >
            <div class="polaroid">
              <img
                loading="lazy"
                src={partner01}
                alt="Second Street Dreams Image."
                style={{ width: "100%" }}
              />
              <div class="polaroid-container">
                <p>2nd Street Dreams</p>
              </div>
            </div>
          </a>
        </div>

        <div class="column-polaroid">
          <a
            href="https://www.dvidshub.net/podcast/48/air-force-radio-news"
            target="_blank"
            rel="noreferrer"
          >
            <div class="polaroid">
              <img
                loading="lazy"
                src={partner02}
                alt="Air Force Radio Image."
                style={{ width: "100%" }}
              />
              <div class="polaroid-container">
                <p>Air Force Radio News</p>
              </div>
            </div>
          </a>
        </div>

        <div class="column-polaroid">
          <a href="https://www.airplay40.com/" target="_blank" rel="noreferrer">
            <div class="polaroid">
              <img
                loading="lazy"
                src={partner03}
                alt="AirPlay40 Image."
                style={{ width: "100%" }}
              />
              <div class="polaroid-container">
                <p>AirPlay 40</p>
              </div>
            </div>
          </a>
        </div>
      </div>

      <div class="partner-row" id="01">
        <div class="column-polaroid">
          <a
            href="https://www.sunny106.fm/onair/mg-kellys-amazing-80s"
            target="_blank"
            rel="noreferrer"
          >
            <div class="polaroid">
              <img
                loading="lazy"
                src={partner04}
                alt="Amazing 80s Image."
                style={{ width: "100%" }}
              />
              <div class="polaroid-container">
                <p>Amazing 80s</p>
              </div>
            </div>
          </a>
        </div>
        <div class="column-polaroid">
          <a
            href="https://americanradiojournal.com/"
            target="_blank"
            rel="noreferrer"
          >
            <div class="polaroid">
              <img
                loading="lazy"
                src={partner05}
                alt="American Radio Journal Image."
                style={{ width: "100%" }}
              />
              <div class="polaroid-container">
                <p>American Radio Journal</p>
              </div>
            </div>
          </a>
        </div>
        <div class="column-polaroid">
          <a
            href="https://www.theartistinterviewpodcast.com/"
            target="_blank"
            rel="noreferrer"
          >
            <div class="polaroid">
              <img
                loading="lazy"
                src={partner06}
                alt="The Artist Interview Image."
                style={{ width: "100%" }}
              />
              <div class="polaroid-container">
                <p>The Artist Interview</p>
              </div>
            </div>
          </a>
        </div>
        <div class="column-polaroid">
          <a
            href="https://www.homecomingradio.com/"
            target="_blank"
            rel="noreferrer"
          >
            <div class="polaroid">
              <img
                loading="lazy"
                src={partner07}
                alt="Homecoming Radio Image."
                style={{ width: "100%" }}
              />
              <div class="polaroid-container">
                <p>Bill Gaither&apos;s Homecoming Radio</p>
              </div>
            </div>
          </a>
        </div>
      </div>

      <div class="partner-row" id="02">
        <div class="column-polaroid">
          <a href="https://birdnote.org/" target="_blank" rel="noreferrer">
            <div class="polaroid">
              <img
                loading="lazy"
                src={partner08}
                alt="Bird Note Image."
                style={{ width: "100%" }}
              />
              <div class="polaroid-container">
                <p>Bird Note</p>
              </div>
            </div>
          </a>
        </div>
        <div class="column-polaroid">
          <a
            href="https://www.consumeraffairs.com/"
            target="_blank"
            rel="noreferrer"
          >
            <div class="polaroid">
              <img
                loading="lazy"
                src={partner09}
                alt="Consumer Affairs Image."
                style={{ width: "100%" }}
              />
              <div class="polaroid-container">
                <p>Consumer Affairs</p>
              </div>
            </div>
          </a>
        </div>
        <div class="column-polaroid">
          <a
            href="https://dailycast.news/blog/category/news/"
            target="_blank"
            rel="noreferrer"
          >
            <div class="polaroid">
              <img
                loading="lazy"
                src={partner10}
                alt="Daily Cast Image."
                style={{ width: "100%" }}
              />
              <div class="polaroid-container">
                <p>Dailycast News</p>
              </div>
            </div>
          </a>
        </div>
        <div class="column-polaroid">
          <a
            href="https://www.faithfi.com/show"
            target="_blank"
            rel="noreferrer"
          >
            <div class="polaroid">
              <img
                loading="lazy"
                src={partner11}
                alt="Faith And Finance Image."
                style={{ width: "100%" }}
              />
              <div class="polaroid-container">
                <p>Faith &amp; Finance Minute </p>
              </div>
            </div>
          </a>
        </div>
      </div>

      <div class="partner-row" id="03">
        <div class="column-polaroid">
          <a
            href="https://www.featurestorynews.com/"
            target="_blank"
            rel="noreferrer"
          >
            <div class="polaroid">
              <img
                loading="lazy"
                src={partner12}
                alt="Feature Story News"
                style={{ width: "100%" }}
              />
              <div class="polaroid-container">
                <p>Feature Story News</p>
              </div>
            </div>
          </a>
        </div>
        <div class="column-polaroid">
          <a
            href="https://humans-in-public-health.captivate.fm/"
            target="_blank"
            rel="noreferrer"
          >
            <div class="polaroid">
              <img
                loading="lazy"
                src={partner13}
                alt="Humans In Public Health Image."
                style={{ width: "100%" }}
              />
              <div class="polaroid-container">
                <p>Humans In Public Health</p>
              </div>
            </div>
          </a>
        </div>
        <div class="column-polaroid">
          <a
            href="https://unconventionalbusiness.org/category/integrity-moments/"
            target="_blank"
            rel="noreferrer"
          >
            <div class="polaroid">
              <img
                loading="lazy"
                src={partner14}
                alt="Integrity Moments Image."
                style={{ width: "100%" }}
              />
              <div class="polaroid-container">
                <p>Integrity Moments</p>
              </div>
            </div>
          </a>
        </div>
        <div class="column-polaroid">
          <a href="https://www.jazztrax.com" target="_blank" rel="noreferrer">
            <div class="polaroid">
              <img
                loading="lazy"
                src={partner15}
                alt="JazzTrax Image."
                style={{ width: "100%" }}
              />
              <div class="polaroid-container">
                <p>JazzTrax</p>
              </div>
            </div>
          </a>
        </div>
      </div>

      <div class="partner-row" id="04">
        <div class="column-polaroid">
          <a
            href="https://www.militaryonesource.mil/resources/podcasts/military-onesource/"
            target="_blank"
            rel="noreferrer"
          >
            <div class="polaroid">
              <img
                loading="lazy"
                src={partner17}
                alt="Military One Source."
                style={{ width: "100%" }}
              />
              <div class="polaroid-container">
                <p>Military One Source</p>
              </div>
            </div>
          </a>
        </div>

        <div class="column-polaroid">
          <a href="https://www.tryitonai.com" target="_blank" rel="noreferrer">
            <div class="polaroid">
              <img
                loading="lazy"
                src={partner19}
                alt="Try It On Image."
                style={{ width: "100%" }}
              />
              <div class="polaroid-container">
                <p>Try It On</p>
              </div>
            </div>
          </a>
        </div>
        <div class="column-polaroid">
          <a
            href="http://www.radioprogramsonline.com/livingwell/"
            target="_blank"
            rel="noreferrer"
          >
            <div class="polaroid">
              <img
                loading="lazy"
                src={partner20}
                alt=" Pam Smith Image."
                style={{ width: "100%" }}
              />
              <div class="polaroid-container">
                <p>Pam Smith</p>
              </div>
            </div>
          </a>
        </div>
        <div class="column-polaroid">
          <a
            href="https://www.askpossibly.org/"
            target="_blank"
            rel="noreferrer"
          >
            <div class="polaroid">
              <img
                loading="lazy"
                src={partner21}
                alt="Possibly Image."
                style={{ width: "100%" }}
              />
              <div class="polaroid-container">
                <p>Possibly</p>
              </div>
            </div>
          </a>
        </div>
      </div>

      <div class="partner-row" id="05">
        <div class="column-polaroid">
          <a
            href="https://www.presidentialprayerteam.org/"
            target="_blank"
            rel="noreferrer"
          >
            <div class="polaroid">
              <img
                loading="lazy"
                src={partner22}
                alt="Presidential Prayer Team Image."
                style={{ width: "100%" }}
              />
              <div class="polaroid-container">
                <p>Presidential Prayer Team</p>
              </div>
            </div>
          </a>
        </div>
        <div class="column-polaroid">
          <a href="https://www.theshm.org/" target="_blank" rel="noreferrer">
            <div class="polaroid">
              <img
                loading="lazy"
                src={partner23}
                alt="Samaritan Health Ministries Image."
                style={{ width: "100%" }}
              />
              <div class="polaroid-container">
                <p>Samaritan Health Ministries</p>
              </div>
            </div>
          </a>
        </div>
        <div class="column-polaroid">
          <a
            href="https://department.va.gov/veterans-experience/va-radio-outreach-program/"
            target="_blank"
            rel="noreferrer"
          >
            <div class="polaroid">
              <img
                loading="lazy"
                src={partner24}
                alt="VA Radio Outreach Image."
                style={{ width: "100%" }}
              />
              <div class="polaroid-container">
                <p>VA Radio Outreach</p>
              </div>
            </div>
          </a>
        </div>
        <div class="column-polaroid">
          <a
            href="https://subscribe.vinylimpressions.club/"
            target="_blank"
            rel="noreferrer"
          >
            <div class="polaroid">
              <img
                loading="lazy"
                src={partner25}
                alt="Vinyl Impressions Image."
                style={{ width: "100%" }}
              />
              <div class="polaroid-container">
                <p>Vinyl Impressions</p>
              </div>
            </div>
          </a>
        </div>
      </div>

      <div div class="divider">
        G2 Radio Network
      </div>

      <div class="partner-row">
        <div class="column-polaroid">
          <div class="polaroid">
            <img
              loading="lazy"
              src={cyber}
              alt="Cyber Forensics Logo."
              style={{ width: "100%" }}
            />
          </div>
        </div>

        <div class="column-polaroid">
          <div class="polaroid">
            <img
              loading="lazy"
              src={drive}
              alt="Drive Jams Logo."
              style={{ width: "100%" }}
            />
          </div>
        </div>

        <div class="column-polaroid">
          <div class="polaroid">
            <img
              loading="lazy"
              src={monthly}
              alt="Monthly Housekeeping Logo."
              style={{ width: "100%" }}
            />
          </div>
        </div>

        <div class="column-polaroid">
          <div class="polaroid">
            <img
              loading="lazy"
              src={motive}
              alt="Motivational Moment Logo."
              style={{ width: "100%" }}
            />
          </div>
        </div>
      </div>

      <div class="partner-row">
        <div class="column-polaroid">
          <div class="polaroid">
            <img
              loading="lazy"
              src={weather}
              alt="Weather Logo."
              style={{ width: "100%" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
